import { Tooltip as CanvasTooltip, TooltipProps } from '@workday/canvas-kit-react/tooltip';
import React from 'react';
import styles from './tooltip.module.scss';

type Tooltip = Omit<TooltipProps, 'title'> & { message: string };

export function Tooltip({ children, message, ...rest }: Tooltip) {
    return (
        <CanvasTooltip
            className={styles.tooltip}
            type='label'
            title={<div className={styles.tooltipMessage}>{message}</div>}
            placement='bottom'
            {...rest}>
            {children}
        </CanvasTooltip>
    );
}
